import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { PrinterOutlined, ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import SupplierOutflowMatrixFilters from "./components/SupplierOutflowMatrixFilters";
import SupplierOutflowMatrixTable from "./components/SupplierOutflowMatrixTable";
import ReportDom from "../../../components/common/ReportDom";
import { exportSupplierOutflowMatrixCsv } from "./components/exportSupplierOutflowMatrixCsv";

const { Title } = Typography;

const SupplierOutflow = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const { matrix } = useSelector((state) => state.supplierOutflow);

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  const handleDownloadCsv = () => {
    exportSupplierOutflowMatrixCsv({
      list: matrix.list,
      year: matrix.filters.year,
      title: "Cash Flow Actual and Projection Matrix Report",
      filename: "supplier_outflow_matrix",
    });
  };

  const hasData = matrix.list.length > 0;

  const reportRef = useRef();
  const documentTitle = matrix.filters.year
    ? `Cash Flow Actual and Projection Matrix Report — ${matrix.filters.year}`
    : "Cash Flow Actual and Projection Report";
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle,
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
              <Title level={4} style={{ margin: 0 }} className="reportBigTitle">
                Cash Flow Actual and Projection Report
              </Title>
            </div>
          }
          extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <SupplierOutflowMatrixFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <SupplierOutflowMatrixTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title={documentTitle}
          mode="report-page"
          renderTable={() => <SupplierOutflowMatrixTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default SupplierOutflow;
